/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTopologyStar2 = createReactComponent("outline", "topology-star-2", "IconTopologyStar2", [["path", { "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M6 12h4", "key": "svg-5" }], ["path", { "d": "M14 12h4", "key": "svg-6" }], ["path", { "d": "M12 6v4", "key": "svg-7" }], ["path", { "d": "M12 14v4", "key": "svg-8" }]]);

export { IconTopologyStar2 as default };
//# sourceMappingURL=IconTopologyStar2.mjs.map
